export class AppRoutes {
	static readonly HOME = '/';
	static readonly SIGN_IN = '/auth/sign-in';
	static readonly PASSWORD_RECOVERY = '/auth/recovery-password';

	// Pasarela
	static readonly CART = '/carrito';
	static readonly CART_PRODUCTS = '/carrito';
	static readonly CART_CHECKOUT = '/carrito/despacho';
	static readonly CART_PAYMENT = '/carrito/pago';
	static readonly CART_CONFIRMATION = '/carrito/confirmacion';

	// Admin
	static readonly DASHBOARD = '/dashboard';
	static readonly ADMIN_PRINCIPAL = '/admin/principales';
	static readonly ADMIN_SOLUTIONS = '/admin/soluciones';
	static readonly ADMIN_PRODUCTS = '/admin/productos';
	static readonly ADMIN_FILES = '/admin/archivos';
	static readonly ADMIN_FILES_MANAGER = '/admin/file-manager';
	static readonly ADMIN_CONTACTS = '/admin/contactos';
	static readonly ADMIN_REQUESTS = '/admin/solicitudes';

	// Misceláneo
	// static readonly CONTACT = '/contacto';
	static readonly STORE = '/tienda';
	static readonly PRODUCTS = '/productos';
	static readonly NEWS = '/noticias';
	static readonly NOT_FOUND = '/not-found';

	// Políticas
	static readonly POLICIES_PRIVACY = '/politicas/privacidad';
	static readonly POLICIES_COOKIES = '/politicas/cookies';
	static readonly POLICIES_TERMS = '/politicas/terminos-condiciones';


	static readonly PROFILE = '/perfil';
}